import React from 'react';
import ImageGallery from 'react-image-gallery';

const GalleryRenderer = ({ comp }) => {
    if (comp.type === 'gallery') {
        const images = (comp.images || []).map(img => ({
            original: img.src,
            thumbnail: img.src,
            description: img.title || ''
        }));

        return (
            <div style={{ width: '100%' }}>
                <style>{`
                    .image-gallery-fullscreen-button {
                        top: 0;
                        right: 0;
                        bottom: auto;
                    }
                    .image-gallery-fullscreen-button .image-gallery-svg {
                        height: 28px;
                        width: 28px;
                    }
                `}</style>
                <ImageGallery
                    items={images}
                    showNav={false}
                    autoPlay={true}
                    slideInterval={7000}
                    showFullscreenButton={true}
                    showPlayButton={false}
                    showThumbnails={false}
                />
            </div>
        );
    }
    return null;
};

export default GalleryRenderer;
